import * as ROUTES from '../routes';
import { MODELS } from './settings';

export const BREADCRUMB_TYPE_FORM = 'form';

export const BREADCRUMB = {
    EVENTS: {
        label: 'EVENTS',
        link: ROUTES.ADMIN_EVENTS_PATH
    },
    EVENTS_FORM: {
        type: BREADCRUMB_TYPE_FORM,
        model: MODELS.EVENT,
        linkCreate: ROUTES.ADMIN_EVENTS_NEW_PATH,
        linkUpdate: ROUTES.ADMIN_EVENTS_DETAILS_PATH
    },
    PARTNERS: {
        label: 'MEDIA PARTNERS',
        link: ROUTES.ADMIN_PARTNERS_PATH
    },
    PARTNERS_FORM: {
        type: BREADCRUMB_TYPE_FORM,
        model: MODELS.PARTNER,
        linkCreate: ROUTES.ADMIN_PARTNERS_NEW_PATH,
        linkUpdate: ROUTES.ADMIN_PARTNERS_DETAILS_PATH
    },
    CONTACTS: {
        label: 'CONTACTS',
        link: ROUTES.ADMIN_CONTACTS_PATH
    },
    CONTACTS_FORM: {
        type: BREADCRUMB_TYPE_FORM,
        model: MODELS.CONTACT,
        idField: 'fullName',
        linkCreate: ROUTES.ADMIN_CONTACTS_NEW_PATH,
        linkUpdate: ROUTES.ADMIN_CONTACTS_DETAILS_PATH
    },
    ARTISTS: {
        label: 'ARTISTS',
        link: ROUTES.ADMIN_ARTISTS_PATH
    },
    ARTISTS_FORM: {
        type: BREADCRUMB_TYPE_FORM,
        model: MODELS.ARTIST,
        linkCreate: ROUTES.ADMIN_ARTISTS_NEW_PATH,
        linkUpdate: ROUTES.ADMIN_ARTISTS_DETAILS_PATH
    },
    CONTRACTS: {
        label: 'CONTRACTS',
        link: ROUTES.ADMIN_CONTRACTS_PATH
    },
    CONTRACTS_FORM: {
        type: BREADCRUMB_TYPE_FORM,
        model: MODELS.CONTRACT,
        linkCreate: ROUTES.ADMIN_CONTRACTS_NEW_PATH,
        linkUpdate: ROUTES.ADMIN_CONTRACTS_DETAILS_PATH
    },
    TEMPLATE_FORM: {
        type: BREADCRUMB_TYPE_FORM,
        model: MODELS.TEMPLATE,
        linkCreate: ROUTES.ADMIN_TEMPLATES_NEW_PATH,
        linkUpdate: ROUTES.ADMIN_TEMPLATES_DETAILS_PATH
    }
};



// WEBPACK FOOTER //
// ./src/constants/admin/breadcrumb.js